require.config({
    'enforceDefine': true,
    'urlArgs': "uid=1550838386823",
    'waitSeconds': 30,
    config: {
        'ps/sentry' : {
            dsn: 'https://2a2993cf452042adbc8c3f694036d322@sentry.io/1284412'
        },
        'ps/facebook-init' : {
            appId: '1903051756669019'
        },
        'ps/leaflet-titlelayer' : {
            url: 'https://maps-tile.e-wczasowicz.pl/{z}/{x}/{y}.png'
        }
    },
    'paths': {
        /**
         * CSS
         */
        'select2-css': '../vendor/jquery.select2-3.5.2/select2',
        'select2-bootstrap-css': '../vendor/jquery.select2-3.5.2/select2-bootstrap',
        'intlTelInput-css': '../vendor/intl-tel-input-11.0.14/build/css/intlTelInput',
        'bootstrap-datepicker-css': '../vendor/bootstrap-datepicker/css/bootstrap-datepicker3',
        'bootstrap-datepicker3-css': '../vendor/bootstrap-datepicker/css/bootstrap-datepicker3',
        'bootstrap-editable-css': '../vendor/bootstrap3-editable/css/bootstrap-editable',
        'fancybox-css': '../vendor/fancyBox/source/jquery.fancybox',
        'fancybox-thumbs-css': '../vendor/fancyBox/source/helpers/jquery.fancybox-thumbs',
        'jquery.daterangepicker-css': 'daterangepicker',
        'jquery.scrollbar-css': '../vendor/jquery.scrollbar-0.2.7/jquery.scrollbar',

        /**
         * JS
         */
        // require-css plugin
        'require-css': 'require-css/require-css', // or whatever the path to require-css is

        'pages-sidebar': 'ps.customized/pages-sidebar',

        'moment': 'ps.customized/momentjs-custom',

        //bootstrap
        'bootstrap': '../vendor/bootstrap-3.3.7/dist/js/bootstrap',

        // jquery.cycle2
        'jquery.cycle2': '../vendor/jquery.cycle2/jquery.cycle2',
        'jquery.cycle2.carousel': '../vendor/jquery.cycle2/jquery.cycle2.carousel',
        'jquery.cycle2.swipe': '../vendor/jquery.cycle2/jquery.cycle2.swipe',

        // single
        'editable': '../vendor/bootstrap3-editable/js/bootstrap-editable',
        // single
        'noUiSlider': '../vendor/noUiSlider/nouislider',
        // single
        'bootstrapSlider': '../vendor/bootstrap-slider/js/bootstrap-slider',

        // requirejs-plugins
        'async': '../vendor/requirejs-plugins/async',
        'goog': '../vendor/requirejs-plugins/goog',
        'noext': '../vendor/requirejs-plugins/noext',
        'propertyParser': '../vendor/requirejs-plugins/propertyParser',

        // jQuery
        'jquery': '../vendor/jquery/jquery-1.11.2',

        // jQuery Plugins
        'jquery.lazyload': '../js/ps/ps.lazyload',
        'jquery.cookie': '../vendor/jquery.cookie-1.4.1/jquery.cookie',
        'jquery.maskedinput': '../vendor/jquery.maskedinput-1.4.1/jquery.maskedinput',
        'jquery.scrollbar': '../vendor/jquery.scrollbar-0.2.7/jquery.scrollbar',
        'jquery.actual': '../vendor/jquery.actual-1.0.19/jquery.actual',
        'jquery.ui': '../vendor/jquery-ui-1.11.4.custom/jquery-ui',
        'jquery.daterangepicker': '../vendor/jquery-date-range-picker/jquery.daterangepicker',
        'select2': '../vendor/jquery.select2-3.5.2/select2',
        'modernizr': '../vendor/modernizr/modernizr.custom',
        'intlTelInput': '../vendor/intl-tel-input-11.0.14/build/js/intlTelInput',
        'intlTelInputUtilites': '../vendor/intl-tel-input-11.0.14/build/js/utils',
        'jquery.ui.datepicker.localization.pl': 'localization/jquery.ui.datepicker/jquery.ui.datepicker-pl',
        'tinyMCE': '../vendor/tinymce-4.5.7/js/tinymce/tinymce',
        'jquery.mobile': '../vendor/jquery.mobile-1.4.5/jquery.mobile.custom',
        'jquery.rwdImageMaps': '../vendor/jquery.rwdImageMaps/jquery.rwdImageMaps',
        'jquery.raty-fa' : '../vendor/raty-fa-0.1.1/lib/jquery.raty-fa',

        // Admin + panel // single
        'pages': '../vendor/pages-revox/pages', //admin + panel
        'bootstrap.datepicker': 'ps.customized/bootstrap-datepicker-with-locales',


        // uploader
        'plupload': '../vendor/plupload-2.3.3/js/plupload.dev',
        'moxie': '../vendor/plupload-2.3.3/js/moxie',

        // lightbox
        'fancyBox': '../vendor/fancyBox/source/jquery.fancybox.pack',
        'fancyBoxThumbPlugin': '../vendor/fancyBox/source/helpers/jquery.fancybox-thumbs',
        'jqueryMouseWheelPlugin': '../vendor/fancyBox/lib/jquery.mousewheel-3.0.6.pack',

        //angular
        'angular': '../vendor/angular-1.2.27/angular',
        'angular.route': '../vendor/angular-1.2.27/angular-route',
        'angular.resource': '../vendor/angular-1.2.27/angular-resource',
        'angular.sanitize': '../vendor/angular-1.2.27/angular-sanitize',
        'angular.strap': '../vendor/angular-strap-0.7.8/angular-strap',
        'angular.locale.pl': '../vendor/angular-1.2.27/i18n/angular-locale_pl-pl',
        'bindonce': '../vendor/bindonce/bindonce',

        'googleMaps' : '//maps.google.com/maps/api/js?v=3.exp&libraries=places&language=pl&key=AIzaSyAQNj2F_SKTqukGQpqiBntps3VaY2lNo5U',
        'googleCharts' : '//www.gstatic.com/charts/loader',

        'd3' : '../vendor/d3-3.5.17/d3',
        'nvd3' : '../vendor/nvd3-1.8.5/build/nv.d3',
        'nvd3-css' : '../vendor/nvd3-1.8.5/build/nv.d3',

        'sentry' : '../vendor/raven-js-3.16.0/dist/raven',
        'livechat': '//cdn.livechatinc.com/tracking',

        'leaflet': '../vendor/leaflet-1.3.3/leaflet',
        'leaflet-css': '../vendor/leaflet-1.3.3/leaflet',
        'leaflet-markercluster' : '../vendor/leaflet.markercluster-1.4.1/dist/leaflet.markercluster',
        'leaflet-markercluster-css' : '../vendor/leaflet.markercluster-1.4.1/dist/MarkerCluster',
        'leaflet-markercluster-default-css' : '../vendor/leaflet.markercluster-1.4.1/dist/MarkerCluster.Default',

        'facebook' : '//connect.facebook.net/pl_PL/sdk',

        'Siema' : '../vendor/siema-1.4.2/siema',
        'SmsCounter': '../vendor/sms-counter/sms-counter',
        'Switchery' : '../vendor/switchery-0.3.6/dist/switchery',
        'Switchery-css' : '../vendor/switchery-0.3.6/dist/switchery'
    },
    'shim': {
        'leaflet-markercluster': {
            'deps': ['leaflet']
        },

        'googleMaps': {
            'exports' : 'google'
        },

        'googleCharts': {
            'exports' : 'google'
        },

        /**
         *  FANCYBOX
         */
        'noUiSlider': {
            'deps': ['require-css!nouislider@after:index']
        },
        // SINGLE PACKAGES
        'fancyBox': {
            'deps': ['jquery', 'jqueryMouseWheelPlugin', 'require-css!fancybox-css@after:index'],
            'exports': 'jQuery'
        },
        'fancyBoxThumbPlugin': {
            'deps': ['jquery', 'fancyBox', 'require-css!fancybox-thumbs-css@after:index'],
            'exports': 'jQuery'
        },
        'jqueryMouseWheelPlugin': {
            'deps': ['jquery'],
            'exports': 'jQuery'
        },
        'livechat': {
            'exports': '__lc'
        },

        /**
         * ANGULAR
         */

        // SINGLE PACKAGES
        'angular': {
            'deps': ['jquery'],
            'exports': 'angular'
        },
        'angular-route': ['angular'],
        'angular.locale.pl': {
            'deps': ['angular'],
            'exports': 'angular'
        },
        'angular.strap': {
            'deps': ['angular'],
            'exports': 'angular'
        },
        'angular.route': {
            'deps': ['angular'],
            'exports': 'angular'
        },
        'angular.resource': {
            'deps': ['angular'],
            'exports': 'angular'
        },
        'angular.sanitize': {
            'deps': ['angular'],
            'exports': 'angular'
        },
        'bindonce': {
            'deps': ['angular'],
            'exports': 'angular'
        },

        /**
         * jQuery
         */
        // SINGLE PACKAGES
        'jquery.lazyload': {
            'deps': ['jquery'],
            'exports': 'jQuery'
        },
        'jquery.scrollbar': {
            'deps': ['jquery', 'require-css!jquery.scrollbar-css'],
            'exports': 'jQuery'
        },
        'jquery.actual': {
            'deps': ['jquery'],
            'exports': 'jQuery'
        },


        'jquery.cycle2': {
            'deps': ['jquery'],
            'exports': 'jQuery'
        },
        'jquery.cycle2.swipe': {
            'deps': ['jquery.cycle2'],
            'exports': 'jQuery'
        },
        'jquery.cycle2.carousel': {
            'deps': ['jquery.cycle2'],
            'exports': 'jQuery'
        },
        'jquery.cycle2.full': {
            'deps': [
                'jquery.cycle2.swipe',
                'jquery.cycle2.carousel'

            ],
            'exports': 'jQuery'
        },
        'jquery.rwdImageMaps': {
            'deps': [
                'jquery'
            ],
            'exports': 'jQuery'
        },
        'jquery.raty-fa' : {
            'deps': ['jquery'],
            'exports': 'jQuery'
        },

        'select2': {
            'deps': [
                'jquery',
                'ps/utils',
                'require-css!select2-css@before:index',
                'require-css!select2-bootstrap-css@after:select2'
            ],
            'exports': 'jQuery'
        },
        'modernizr': {
            'exports': 'Modernizr'
        },
        'intlTelInput': {
            'deps': ['jquery', 'intlTelInputUtilites'],
            'exports': 'jQuery'
        },
        'intlTelInputUtilites': {
            'deps': ['jquery', 'ps/utils', 'require-css!intlTelInput-css@after:index'],
            'exports': 'jQuery'
        },
        'jquery.ui.datepicker.localization.pl': {
            'deps': ['jquery.ui'],
            'exports': 'jQuery'
        },
        'jquery.daterangepicker': {
            'deps': ['require-css!jquery.daterangepicker-css@after:index'],
            'exports': 'jQuery'
        },
        'jquery.ui': {
            'deps': ['jquery'],
            'exports': 'jQuery'
        },

        'tinyMCE': {
            exports: 'tinyMCE',
            init: function () {
                this.tinyMCE.DOM.events.domLoaded = true;
                return this.tinyMCE;
            }
        },

        'nvd3' : {
            'deps': ['d3', 'require-css!nvd3-css@after:index'],
            'exports': 'nv'
        },

        /**
         * ADMIN AND PANEL
         */
        // SINGLE PACKAGES
        'pages': {
            'deps': [
                'jquery',
                'modernizr',
                'bootstrap',
                'jquery.scrollbar',
                'jquery.actual',
                'ps/notification'
            ],
            'exports': 'jQuery'
        },
        'bootstrap.datepicker': {
            'deps': [
                'jquery',
                'jquery.ui',
                'require-css!bootstrap-datepicker-css@after:index'
            ],
            'exports': 'jQuery'
        },
        /**
         * UPLOADER
         */
        'plupload': {
            'deps': ['moxie'],
            'exports': 'plupload'
        },
        'moxie': {
            'exports': 'moxie'
        },

        // SINGLE
        'bootstrap': {
            'deps': ['jquery'],
            'exports': 'jQuery'
        },

        // SINGLE
        'bootstrapSlider': {
            'deps': ['jquery', 'jquery.ui'],
            'exports': 'jQuery'
        },

        'editable': {
            'deps': ['jquery', 'ps/utils', 'bootstrap', 'require-css!bootstrap-editable-css@after:index'],
            'exports': 'jQuery'
        },

        'facebook' : {
            'exports': 'FB'
        },
        'Switchery' : {
            'deps' : ['require-css!Switchery-css@after:index'],
            'exports' : 'Switchery'
        },

        'leaflet' : {
            'deps' : ['require-css!leaflet-css@after:index'],
            'exports' : 'Leaflet'
        }
    },

    'packages': [{
        'name': 'ps',
        'location': 'ps'
    }, {
        'name': 'jquery.validate',
        'main': 'jquery.validate',
        'location': '../vendor/jquery.validation-1.17.0/dist'
    }, {
        'name': 'common',
        'location' : 'common'
    }]
});